module.exports = "/shifts/components/calendarHeader/calendarHeader-6ebb68.html";